import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.components.react-error-boundary`, {
  'error-boundary.body': `We have been notified of this error and are working to fix it. Please reload the page.`,
  'error-boundary.body-minimal': `Error`,
  'error-boundary.header': `Something went wrong`,
});
